import { styled } from "~/generated/styled-system/jsx"
import { text as textRecipe } from "~/generated/styled-system/recipes"

/** UI text in the body face (meta lines, status and error messages). Defaults to `<p>`; pass `as` to change it. */
export const Text = styled("p", textRecipe)
